import React from "react";
import history from "../../Assets/Images/history.png";

const History = () => {
  return (
    <div className="w-full sm:w-[90%] mx-auto p-10 bg-[#fff] gap-6 flex-wrap my-10 flex ">
      <div className="items-center mb-4 w-full gap-3 flex flex-wrap  justify-between">
        <h3 className="font-[600] text-[30px] sm:text-[44px] text-[#000] leading-[35px] sm:leading-[41px] ">
          Brief history
          <br /> about us
        </h3>
        <h4 className="font-[400] max-w-[438px] text-[14px] sm:text-[18px] text-[#000] sm:leading-[22px] ">
          Greengate Pharmaceuticals Limited, founded on May 4, 2011, specializes
          in manufacturing, dispensing, and selling high-quality pharmaceutical
          drugs and supplements.
        </h4>
      </div>
      <div className="w-full">
        <img
          src={history}
          alt=""
          className="h-[129px] sm:max-h-[75vh] w-full sm:h-[442px] object-cover"
        />
      </div>
    </div>
  );
};

export default History;
